import { OTP_LENGTH } from "$lib/constants/two-factor"
import { TWO_FACTOR_TYPE } from "@tastyworks/shared-utils/misc/constants"
import { boolean, mixed, object, string } from "yup"

export const setupSchema = object({
  needsToEnterOtp: boolean().default(false),
  isActive: boolean()
    .nullable()
    .default(false)
    .transform((value) => value ?? false),
  alreadySubmitted: boolean().default(false),
})

export const methodSelectionSchema = object({
  type: mixed<TWO_FACTOR_TYPE>()
    .oneOf(Object.values(TWO_FACTOR_TYPE))
    .required(),
})

export const otpSchema = object({
  otp: string().required().length(OTP_LENGTH),
})

export const twoFactorAuthSchema = object({
  twoFaSetup: setupSchema,
  methodSelection: methodSelectionSchema,
  sms: otpSchema,
  authenticator: otpSchema,
})
